// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__EsY3P","iconWithCounter":"styles_iconWithCounter__1cPhv","counterForLabel":"styles_counterForLabel__FZqGp","counterForIcon":"styles_counterForIcon__iGyBT"};